exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.minicart-count[data-v-410561b4] {\n  top: 7px;\n  left: 50%;\n  min-width: 16px;\n  min-height: 16px;\n  border-radius: 10px;\n}\n.fs11[data-v-410561b4] {\n  font-size: 11px\n}\n", ""]);

// exports
